export const getContentfullImagePath = (url: string) => {
  try {
    return new URL(url, process.env.NEXT_PUBLIC_IMAGE_BASE).pathname;
  } catch (_err) {
    return "";
  }
};
